import { TransferBatchRepository } from '~/repositories/Transfer/TransferBatchRepository';
import { TransferBatch } from '~/typings/API';

import { createApiHook } from './utils/createApiHook';

export const useTransferBatch = createApiHook<TransferBatch, GetRequestType>(TransferBatchRepository.get);
